<template>
    <FilterBody
        :label="t('projectclient.projectlist.table.startDate.header')"
        :display-reset="!!searchParams.startDateFrom || !!searchParams.startDateTo"
        @reset="projectListFiltersStore.handleResetCategory('startDateFrom', 'startDateTo')"
    >
        <CalendarInputs v-model:from="screenSizeSearchParams.startDateFrom" v-model:to="screenSizeSearchParams.startDateTo" />
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListFiltersStore, useProjectsListStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import CalendarInputs from './CalendarInputs.vue';
    import FilterBody from '../../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed({
        get: () => {
            if (isSmallScreen.value) {
                return temporarySearchParams.value;
            } else {
                return searchParams.value;
            }
        },
        set(value) {},
    });
</script>
